import { Attachment } from '@progress/kendo-react-conversational-ui';
import { Media } from 'twilio-chat/lib/media';

import { CrossFrameMessageType } from '../lib/postMessage';
import { ITimeSlot } from './ITimeSlot';

export default interface ITwilioMessage {
  body: string;
  author: string;
  timestamp: Date;
  attributes?: {
    id?: string;
    count?: number;
    batch?: number;
    action?: ChatAction;
    actions?: ITwilioMessageAction[];
    name?: string;
    GAEventType?: CrossFrameMessageType;
    extraGAEventInfo?: string;
    status?: string;
    type?: string;
  };
  media?: Media;
  type: string;
  index: number;
}

interface ITwilioMessageAction {
  name: string;
  action: ChatAction;
  payload: IActionPayload;
}

interface IActionPayload {
  suggestedActions?: string[];
  timeSlotData?: ITimeSlot[];
  providers?: ITimeSlot[];
}

export enum ChatAction {
  GetPhone = 'get-phone',
  GetAddress = 'get-address',
  ShowTimeSlots = 'show-timeslots',
  ShowTimeSlotsMedia = 'show-timeslots-media',
  ApproveTimeslot = 'approve-timeslot',
  SuggestAction = 'suggest-action',
  SuggestProviders = 'suggest-providers',
  ShowImage = 'show-image',
  EnableInput = 'enable-input',
  DisableInput = 'disable-input',
  TransferringChat = 'transferring-chat',
  EndingChat = 'ending-chat',
  EscalatedToAgent = 'escalated-to-agent',
}

export interface IAttachment extends Attachment {
  messageId: string;
}

export interface IProvider {
  isSubcontractorMatch?: boolean;
  name: string;
  partnerId: string;
  address: IProviderAddress;
  distanceInMeters?: number;
}

export interface IField {
  entity: string;
  label: string;
}

export interface IProviderAddress {
  addressLine1: string;
  addressLine2?: string;
  locality: string;
  region: string;
  postalCode: string;
  countryCode: string;
}
